import { updateAdminMe, updateAdminSecurity } from '../../../api/adminMeApi';

export async function setMyMagicLinkRequirement({ requireMagicLink }) {
  return updateAdminSecurity({ requireMagicLink: Boolean(requireMagicLink) });
}

export async function setMyTwoFactorMethod({ method }) {
  return updateAdminSecurity({ twoFactorMethod: method === 'sms' ? 'sms' : 'email' });
}

export async function updateMyAdminProfile(profileData) {
  return updateAdminMe(profileData || {});
}
